var description_default = {
  "subtitle": "_4QN4e",
  "descriptionItem": "eSNgH"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
